import { useState } from 'react';
import type { FormEvent } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import type { Period, PeriodInput } from './api';

export function PeriodForm(props: {
  initial?: Period;
  submitLabel: string;
  pending: boolean;
  onSubmit: (input: PeriodInput, reset: () => void) => void;
  onCancel?: () => void;
}) {
  const { initial, submitLabel, pending, onSubmit, onCancel } = props;
  const [label, setLabel] = useState(initial?.label ?? '');
  const [startTime, setStartTime] = useState(initial?.startTime ?? '');
  const [endTime, setEndTime] = useState(initial?.endTime ?? '');
  const [isBreak, setIsBreak] = useState(initial?.isBreak ?? false);

  function submit(event: FormEvent) {
    event.preventDefault();
    if (!label.trim() || !startTime || !endTime) return;
    onSubmit({ label: label.trim(), startTime, endTime, isBreak }, () => {
      setLabel('');
      setStartTime('');
      setEndTime('');
      setIsBreak(false);
    });
  }

  return (
    <form onSubmit={submit} className="flex flex-wrap items-end gap-3">
      <label className="flex min-w-40 flex-1 flex-col gap-1">
        Naam
        <Input value={label} maxLength={40} onChange={(event) => setLabel(event.target.value)} className="min-h-11" />
      </label>
      <label className="flex flex-col gap-1">
        Van
        <input type="time" value={startTime} onChange={(event) => setStartTime(event.target.value)} className="min-h-11 rounded border px-2" />
      </label>
      <label className="flex flex-col gap-1">
        Tot
        <input type="time" value={endTime} onChange={(event) => setEndTime(event.target.value)} className="min-h-11 rounded border px-2" />
      </label>
      <label className="flex min-h-11 items-center gap-2">
        <input type="checkbox" checked={isBreak} onChange={(event) => setIsBreak(event.target.checked)} />
        Pauze
      </label>
      <Button type="submit" variant="outline" disabled={pending} className="min-h-11">
        {submitLabel}
      </Button>
      {onCancel && (
        <Button type="button" variant="link" onClick={onCancel} className="h-auto min-h-11 px-0">
          Annuleren
        </Button>
      )}
    </form>
  );
}
